export default [
  {
    path: '/setting/lamp',
    component: () => import('@/views/setting/lamp.vue'),
    name: 'setting.lamp',
    meta: {
      title: '车辆灯效设置',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
];
